import { styled } from "@mui/material";
import * as React from "react";
import { PropsWithChildren } from "react";

const Container = styled("div")(
    ({ theme }) => (
        {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            color: theme.palette.muted.main,
            width: "inherit",
            minHeight: 40
        })
);

export const MprcFilterLine: React.FC<PropsWithChildren> = ({ children }) => {
    return <Container>{children}</Container>;
};
